import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';

interface AbstractControlWithListener extends AbstractControl {
  _requiredIfChangeListener?: Subscription;
}

export function requiredIf(
  controlName: string,
  operator: string,
  conditionalValue: string | boolean,
): ValidatorFn {
  return (control: AbstractControlWithListener): ValidationErrors | null => {
    const form = control.parent;
    const linkedControl = form?.get(controlName);

    // Revalidate the dependent control when the linked control's value changes
    control._requiredIfChangeListener = linkedControl?.valueChanges.subscribe(
      () => {
        control.updateValueAndValidity();
      },
    );

    if (
      linkedControl &&
      Function(
        `"use strict"; return '${linkedControl.value}' ${operator} '${conditionalValue}'`,
      )()
    ) {
      return Validators.required(control);
    }
    control?.setErrors(null);
    return null;
  };
}

export function requiredAll(validators: ValidatorFn[]): ValidatorFn {
  return (control: AbstractControlWithListener): ValidationErrors | null => {
    const results = validators.map((validator) => validator(control));

    if (results.every((res) => res?.['required'])) {
      return { required: true };
    }

    return null;
  };
}
